<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>I was told, “everyone has a book in them”; when I retired, I tried out that statement. I enjoyed doing it and have had my first book published.</p><br/>
<p style="text-indent:0em">This has given me a great sense of satisfaction. Having created a cast of characters, I aim to use them in future stories.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?7819b862